import { GlobalOutlined } from '@ant-design/icons'
import React from 'react'

import { RequestedPostLinkFragment } from '@/generated/graphql'

import s from './post-card.module.less'

interface PostCardLinkProps {
  link: RequestedPostLinkFragment
}

const PostLink: React.FC<PostCardLinkProps> = ({ link }) => {
  const onClick = () => {
    window.open(link.url, '__blank', 'noopener,noreferrer')
  }

  return (
    <div className={s.link} onClick={onClick}>
      <div className={s.linkHeader}>
        <div className={s.linkAvatar}>
          {link.logo ? <img width='16' height='16' src={link.logo} /> : <GlobalOutlined />}
        </div>
        <div className={s.linkTitle}>{link.title || link.url}</div>
      </div>
      {link.description && <div className={s.linkContent}>{link.description}</div>}
    </div>
  )
}

interface PostCardLinksProps {
  links: RequestedPostLinkFragment[]
}

export const PostCardLinks: React.FC<PostCardLinksProps> = ({ links }) => {
  if (links.length === 0) {
    return null
  }

  return (
    <div className={s.linksContainer}>
      {links.map((link, i) => (
        <PostLink key={i} link={link} />
      ))}
    </div>
  )
}
